const brand = {
    50: {
        value: '#fff5f5',
    },
    100: {
        value: '#ffeaea',
    },
    200: {
        value: '#ffc9c9',
    },
    300: {
        value: '#ffa6a6',
    },
    400: {
        value: '#ff8282',
    },
    500: {
        value: '#ff6767',
    },
    600: {
        value: '#ff4c4c',
    },
    700: {
        value: '#ff4545',
    },
    800: {
        value: '#ff3c3c',
    },
    900: {
        value: '#E01E16',
    },
    950: {
        value: '#c21111',
    },
};

const secondary = {
    50: {
        value: '#ebf1f8',
    },
    100: {
        value: '#e0eaf4',
    },
    200: {
        value: '#b3cbe3',
    },
    300: {
        value: '#80a8d0',
    },
    400: {
        value: '#4d85bd',
    },
    500: {
        value: '#266aae',
    },
    600: {
        value: '#0050a0',
    },
    700: {
        value: '#004998',
    },
    800: {
        value: '#00408e',
    },
    900: {
        value: '#003784',
    },
    950: {
        value: '#002773',
    },
};

export const colors = {
    red: brand,
    brand,

    blue: secondary,
    secondary,

    orange: {
        50: {
            value: '#fff9eb',
        },
        100: {
            value: '#fff6e0',
        },
        200: {
            value: '#ffe9b3',
        },
        300: {
            value: '#ffda80',
        },
        400: {
            value: '#ffcb4d',
        },
        500: {
            value: '#ffbf26',
        },
        600: {
            value: '#ffb400',
        },
        700: {
            value: '#ffad00',
        },
        800: {
            value: '#ffa400',
        },
        900: {
            value: '#ff9c00',
        },
        950: {
            value: '#ff8c00',
        },
    },

    gray: {
        50: {
            value: '#fafafa',
        },
        100: {
            value: '#f5f5f5',
        },
        200: {
            value: '#eeeeee',
        },
        300: {
            value: '#e0e0e0',
        },
        400: {
            value: '#bdbdbd',
        },
        500: {
            value: '#717171',
        },
        600: {
            value: '#5f5f5f',
        },
        700: {
            value: '#4e4e4e',
        },
        800: {
            value: '#3c3c3c',
        },
        900: {
            value: '#212121',
        },
        950: {
            value: '#111111',
        },
    },

    green: {
        50: {
            value: '#f4faf3',
        },
        100: {
            value: '#eef7ed',
        },
        200: {
            value: '#d5ebd2',
        },
        300: {
            value: '#53ad53',
        },
        400: {
            value: '#309c30',
        },
        500: {
            value: '#0d8c0e',
        },
        600: {
            value: '#007f01',
        },
        700: {
            value: '#007701',
        },
        800: {
            value: '#007001',
        },
        900: {
            value: '#016a02',
        },
        950: {
            value: '#026203',
        },
    },

    yellow: {
        50: {
            value: '#fdfdf7',
        },
        100: {
            value: '#fffce7',
        },
        200: {
            value: '#fef8c2',
        },
        300: {
            value: '#fdf39a',
        },
        400: {
            value: '#fcee71',
        },
        500: {
            value: '#fceb52',
        },
        600: {
            value: '#fbe734',
        },
        700: {
            value: '#fae42f',
        },
        800: {
            value: '#fae027',
        },
        900: {
            value: '#f9dd21',
        },
        950: {
            value: '#f8d715',
        },
    },
};
